<template>
  <div class="w-auto sheet-collection">
    <ButtonUpload :value="typeof sheetValue.attachment == 'object' ? sheetValue.attachment : null" @changeValue="sheetValue.attachment = $event" class="mt-0 mr-2" />
  </div>
  <div class="w-100">
    <div class="d-flex align-items-center">
      <label class="mb-0 mr-2">Sheet name:</label>
      <input type="text" v-model="sheetValue.sheet" class="form-control" placeholder="Name" style="width: 200px" />
    </div>
    <div class="d-flex align-items-center">
      <label class="mt-2">Inputs:</label>
      <i class="icon ti ti-square-rounded-plus ml-2" @click="addSheetInput"></i>
    </div>
    <div v-for="(object, key) in sheetValue.inputs" :key="key" class="d-flex align-items-center sheet-collection-inputs">
      <SheetInputPackage :config="config" :object="object" @changeValue="changeSheetInputValue(key, $event)" />
      <i class="icon remove ti ti-square-rounded-minus" @click="removeSheetInput(key)"></i>
    </div>
    <div class="d-flex align-items-center">
      <label class="mt-2">Outputs:</label>
      <i class="icon ti ti-square-rounded-plus ml-2" @click="addSheetOutput"></i>
    </div>
    <div v-for="(object, key) in sheetValue.outputs" :key="key" class="d-flex align-items-center sheet-collection-inputs">
      <SheetOutputPackage :config="config" :object="object" @changeValue="changeSheetOutputValue(key, $event)" />
      <i v-if="!object.default" class="icon remove ti ti-square-rounded-minus" @click="removeSheetOutput(key)"></i>
    </div>
  </div>
</template>

<script>
import DefaultValue from './DefaultValue.vue'
import ButtonUpload from '@/components/ButtonUpload.vue'
import SheetInputPackage from './Packages/SheetInputPackage.vue'
import SheetOutputPackage from './Packages/SheetOutputPackage.vue'
export default {
  extends: DefaultValue,
  components: {
    ButtonUpload,
    SheetInputPackage,
    SheetOutputPackage
  },
  data() {
    return {
      originAttachment: null,
      sheetValue: {
        attachment: null,
        sheet: '',
        inputs: [
          {
            package: '',
            field: '',
            range: ''
          }
        ],
        outputs: [
          {
            package: '',
            field: '',
            range: ''
          }
        ]
      }
    }
  },
  computed: {
    data() {
      return this.store.getter(this.storeId)
    }
  },
  methods: {
    addSheetInput() {
      this.sheetValue.inputs.push({
        package: '',
        field: '',
        range: ''
      })
    },
    removeSheetInput(key) {
      this.sheetValue.inputs.splice(key, 1)
      if (this.sheetValue.inputs.length > 0) return
      this.sheetValue.inputs.push({
        package: '',
        field: '',
        range: ''
      })
    },
    changeSheetInputValue(key, { field, value }) {
      this.sheetValue.inputs[key][field] = value
    },
    addSheetOutput() {
      this.sheetValue.outputs.push({
        package: '',
        field: '',
        range: ''
      })
    },
    changeSheetOutputValue(key, { field, value }) {
      this.sheetValue.outputs[key][field] = value
    },
    removeSheetOutput(key) {
      this.sheetValue.outputs.splice(key, 1)
    }
  },
  watch: {
    sheetValue: {
      handler(value) {
        const jsonValue = JSON.stringify(value)
        if (jsonValue == this.data.value) return
        this.store.commit(`${this.storeId}.value`, jsonValue)
      },
      deep: true
    },
    data: {
      handler(value) {
        let packageValue = {
          sheet: '',
          inputs: [
            {
              package: '',
              field: '',
              range: ''
            }
          ],
          outputs: [
            {
              package: '',
              field: '',
              range: ''
            }
          ]
        }
        try {
          packageValue = Object.assign(packageValue, JSON.parse(value.value))
        } catch (e) {
          console.log(e)
        }

        if (!_.isEqual(this.sheetValue, packageValue)) {
          this.sheetValue = packageValue
        }

        if (!this.sheetValue.outputs?.[0]) {
          this.sheetValue.outputs[0] = {}
        }
        this.sheetValue.outputs[0].package = value.package
        this.sheetValue.outputs[0].field = value.field
        this.sheetValue.outputs[0].default = true
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style lang="scss">
body.page-automation {
  .package-item {
    label.upload-file {
      min-height: 38px !important;
    }
  }
  .sheet-collection {
    .btn-upload-wrapper {
      button {
        margin-top: 0;
        padding-left: 10px;
      }
    }
  }
  .sheet-collection-inputs {
    .icon.remove {
      position: static;
    }
  }
}
</style>
